import ApiCall from 'Helpers/ApiCall';
import { actionType } from 'Config/actionTypes';
import {
  API_JOB_POSITION,
  API_BRANCHES_FILTER,
  API_ORGANIZATIONS_FILTER,
  API_JOBS_FILTER,
  API_CNAME,
} from 'Config/api';
import {
  GetAPIAttendanceBaseURL,
  GetTokenAttendance,
  cidWithPrefix,
  GetAPIBaseURL,
} from 'Helpers';

export const getJobPosition =
  (keywords = '') =>
  (dispatch) => {
    ApiCall(
      dispatch,
      actionType.JOB_POSITION,
      'GET',
      GetAPIAttendanceBaseURL(),
      `${API_JOB_POSITION}?company_id=${cidWithPrefix(
        'enc'
      )}&search_term=${keywords}`,
      {
        company_id: cidWithPrefix('enc'),
      },
      GetTokenAttendance()
    );
  };

export const getBranchFilter =
  () =>
  (dispatch) => {
    ApiCall(
      dispatch,
      actionType.BRANCH_FILTER,
      'GET',
      GetAPIBaseURL(),
      API_BRANCHES_FILTER,
      GetTokenAttendance()
    );
  };

export const getOrganizationFilter =
  () =>
  (dispatch) => {
    ApiCall(
      dispatch,
      actionType.ORGANIZATION_FILTER,
      'GET',
      GetAPIBaseURL(),
      API_ORGANIZATIONS_FILTER,
      GetTokenAttendance()
    );
  };

export const getJobPositionFilter =
  (filterActionType) =>
  (dispatch) => {
    ApiCall(
      dispatch,
      filterActionType,
      'GET',
      GetAPIBaseURL(),
      API_JOBS_FILTER,
      GetTokenAttendance()
    );
  };

  export const getCname = () => (dispatch) => {
    ApiCall(
      dispatch,
      actionType.CNAME,
      'GET',
      GetAPIBaseURL(),
      API_CNAME,
    );
  };
  
